module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M12.009 32h5.977l.004-16 5.428-.002.582-5.514h-6.014l.008-2.76c0-1.438.097-2.208 2.155-2.208h3.8V0h-5.45c-5.28 0-6.496 2.738-6.496 7.236l.006 3.248L8 10.486V16h4.009v16z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/facebook.svg
// module id = 678
// module chunks = 0